import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Types } from 'src/app/constants/gift-card-type';
import { HttpService } from 'src/app/services/http.service';

@Component({
  selector: 'app-my-gift-cards',
  templateUrl: './my-gift-cards.component.html',
  styleUrls: ['./my-gift-cards.component.scss'],
})
export class MyGiftCardsComponent implements OnInit, OnDestroy {
  private _routeObs = new Subscription();
  public giftCards: any[] = [];

  constructor(private _route: ActivatedRoute, private _httpSv: HttpService) {
    this._routeObs.add(
      this._route.queryParamMap.subscribe((params) => {
        this.getMyGiftCards(params.get('coupon'));
      })
    );
  }

  ngOnInit() {}

  async getMyGiftCards(value) {
    const params = {
      typeOfConsumption: value ? Types.COUPON : Types.GIFT_CARD,
    };
    const res = await this._httpSv.itemIndex('giftCard/user', '', params);
    this.giftCards = res.data;
  }

  ngOnDestroy(): void {
    this._routeObs.unsubscribe();
  }
}
